import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./context/authContext";
import { canAccessAdmin } from "./utilities/pageAccess";

const AdminRoute = ({ children }) => {
    const { user, isAuthenticated, loading, hasPermission } = useAuth();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
                fontSize: '16px'
            }}>
                Checking admin permissions...
            </div>
        );
    }

    if (!isAuthenticated) {
        console.log("Not authenticated for admin route");
        return <Navigate to="/login" replace />;
    }

    const normalizedRoles = [
        user?.role?.role_name,
        user?.role?.role_type,
        user?.user_role_name,
        user?.user_role,
    ]
        .map((value) => String(value || "").trim().toLowerCase())
        .filter(Boolean);
    const resolvedRole = normalizedRoles[0] || "";
    const isSuperAdmin =
        Number(user?.user_id) === 1 ||
        normalizedRoles.includes("superadmin") ||
        normalizedRoles.includes("super admin");
    const isAdmin =
        normalizedRoles.includes("admin") ||
        normalizedRoles.includes("administrator");
    const hasAdminPermissionAccess = canAccessAdmin(hasPermission, user);
    if (!user || (!isAdmin && !isSuperAdmin && !hasAdminPermissionAccess)) {
        console.log(
            `Admin access denied for role: ${user?.user_role} (resolved: ${resolvedRole || "n/a"})`
        );
        return <Navigate to="/" replace />;
    }

    return children;
};

export default AdminRoute;
